import { render, staticRenderFns } from "./Table.component.vue?vue&type=template&id=74043511"
import script from "./Table.component.vue?vue&type=script&lang=js"
export * from "./Table.component.vue?vue&type=script&lang=js"
import style0 from "./Table.component.vue?vue&type=style&index=0&id=74043511&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports